/* eslint react-hooks/exhaustive-deps: 0 */
/* eslint @typescript-eslint/no-unused-vars: 0 */
import React, { ReactNode, useEffect, useState } from "react";
import { validateInputDependencies } from "../../../../helpers/helper-input";
import { formatFormikToValidate } from "../../../../helpers/helper-object";
import IField from "../../../../interfaces/field";

type IProps = any &
  IField & {
    children: ReactNode;
  };

const DependencyValidator: React.FC<IProps> = ({
  name,
  prefixName,
  children,
  ...el
}: IProps) => {
  const [canShow, setCanShow] = useState(false);

  useEffect(() => {
    const controller = new AbortController();
    (() => {
      const thisFieldCanShow = validateInputDependencies(
        el.dependencies,
        el.values,
        prefixName
      );

      if (!thisFieldCanShow) {
        const formattedFormikValues = formatFormikToValidate(el.values);

        if (
          formattedFormikValues[name] &&
          formattedFormikValues[name] !== "" &&
          formattedFormikValues[name] !== "null"
        ) {
          if (typeof formattedFormikValues[name] === "string") {
            el.setFieldValue(name, null);
          }
        }
      }
      setCanShow(thisFieldCanShow);
    })();
    return () => controller?.abort();
  }, [el]);

  if (!canShow) return null;

  return children;
};

export default DependencyValidator;
